import { render, staticRenderFns } from "./EduIcon.vue?vue&type=template&id=48a9c260&scoped=true&"
import script from "./EduIcon.vue?vue&type=script&lang=js&"
export * from "./EduIcon.vue?vue&type=script&lang=js&"
import style0 from "./EduIcon.vue?vue&type=style&index=0&id=48a9c260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9c260",
  null
  
)

export default component.exports